import styled from 'styled-components';

const ContentMedium = styled.span`
  font-size: 18px;
  color: #173c51;
  font-weight: 300;
`;

export default ContentMedium;
